











































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { TableColumnConfig, TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';

@Component({
  components: {
    ...UUIFComponent,
  },
})
export default class SysLogAnaltyics extends SwExtendedVue {
  @Prop()
  showSysLogAnaltyicsDialog: boolean;
  @Prop()
  options: [];
  @Prop()
  tradeInSerials: TableEntry[];
  @Prop()
  selectedSerialNumber: string;
  addressType: string = 'NEW';
  selectedSerial: string = '';
  columnConfig: TableColumnConfig[] =
    [{
      key: 'serialnumber',
      dataKey: 'serialnumber',
      title: 'Serial Number',
    }, {
      key: 'name',
      dataKey: 'name',
      sorter: true,
      title: 'Name',
    }];
  closeDialog() {
    this.$emit('closeDialog');
  }
  onSingleSelectEntry(selectedItem: any) {
    this.selectedSerial = this.tradeInSerials[selectedItem.entryKey].serialnumber;
  }
  mounted() {
    this.tradeInSerials.map((each: any, index: number) => each._key = index);
  }
  update() {
    const request = {
      serialNumber : this.selectedSerialNumber,
      tenantType: this.addressType,
      tenantSerial : '',
    };
    if (request.tenantType === 'EXISTING') {
      if (this.selectedSerial === '') {
        return;
      }
      request.tenantSerial = this.selectedSerial;
    }
    this.$emit('closeDialog', request);
  }
}
